<template>
  <div>
    <transition
      name="fade-ads"
      mode="out-in"
    >
      <img
        :key="ads[activeAd]"
        :src="'/storage/ads/' + ads[activeAd] + '?cacheBuster=' + cacheBuster"
        :alt="ads[activeAd]"
        class="img-fluid"
      >
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Ad',
  props: {
    ads: {
      type: Array,
      default() {
        return [];
      },
    },
    adChange: {
      type: Number,
      required: true,
    },
    cacheBuster: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeAd: 0,
    };
  },
  watch: {
    adChange() {
      this.activeAd++;
      if (this.activeAd === this.ads.length) {
        this.activeAd = 0;
      }
    },
  },
};
</script>
